import React, { useContext } from 'react';

import { UploadedFile } from '../../../../api-client';
import IdentificationContext from '../../../context/IdentificationContext';
import IdentificationFileUpload from '../IdentificationFileUpload';

const EntrepreneurScanUpload = () => {
  const context: any = useContext(IdentificationContext);

  const loadFiles = (files: Array<UploadedFile>) => {
    context.setEntrepreneurDocument(files);
  };

  return (
    <IdentificationFileUpload
      prefix="entrepreneur"
      text="Свидетельство о регистрации ФЛ как ИП,ЕГРИП"
      files={context.entrepreneurDocument}
      onUploaded={loadFiles}
    />
  );
};

export default EntrepreneurScanUpload;
